import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
    QueryList,
    ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ApiService } from "../services/api.service";
import { ArticlePreviewComponent } from "./article-preview/article-preview.component";

@Component({
    selector: "ngx-blog",
    templateUrl: "./blog.component.html",
    styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
    @ViewChildren("article", { read: ElementRef })
    articlesDisplayed: QueryList<ElementRef>;

    @ViewChildren("article")
    articlesDisplayedComponents: QueryList<ArticlePreviewComponent>;
    public articles: any;
    public crowdsaleAddress: string;
    public totalArticles: number;
    public blogsNotFound: boolean = false;
    public uniqueCategories: string[];
    constructor(
        private _aS: ApiService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute
    ) {}

    @HostListener("window:scroll", ["$event"])
    isScrolledIntoView() {
        if (this.articlesDisplayed) {
            // console.log(this.articlesDisplayed);

            this.articlesDisplayed.forEach((element, i) => {
                // console.log(i);
                // if (i == this.articles.length) {
                //     console.log("displayed article at index ", i);
                // }
                // console.log("totalArticles length", this.articles.length);
                // console.log(element.nativeElement.offsetWidth);
                const rect = element.nativeElement.getBoundingClientRect();
                // console.log(rect);
                const topShown = rect.top >= 0;
                const bottomShown = rect.bottom <= window.innerHeight;
                if (topShown && bottomShown) {
                    if (
                        this.articles[this.articles.length - 1] ==
                        this.articlesDisplayedComponents.last.articleData
                    ) {
                        console.log("last");
                        console.log(
                            this.articlesDisplayedComponents.last.articleData
                        );
                    }
                    // console.log(this.articlesDisplayedComponents.last);
                    // console.log("shownArticle", element);
                    // console.log(this.articlesDisplayed[i]);
                }
            });
            // this.articlesDisplayed.forEach((article) => {
            //     const rect = article.nativeElement.
            // });
        }
    }

    ngOnInit(): void {
        this._activatedRoute.params.subscribe((paramData) => {
            this.crowdsaleAddress = paramData.contractAddress;
        });
        this._aS.getCrowdsaleBlogs(this.crowdsaleAddress, 0, 2).subscribe(
            (results) => {
                let articleCategories: string[] = [];
                this.articles = results.articles;
                this.totalArticles = results.totalArticles;

                this.articles.forEach((article) => {
                    articleCategories.push(...article.categories);
                });
                this.uniqueCategories =
                    this.removeDuplicateCategories(articleCategories);
            },
            (err) => {
                this.blogsNotFound = true;
            }
        );
    }

    removeDuplicateCategories(arr: Array<string>) {
        let unique: string[] = [];
        arr.forEach((string) => {
            if (!unique.includes(string)) {
                unique.push(string);
            }
        });
        return unique;
    }

    onBackToCrowdsale() {
        this._router.navigateByUrl("/" + this.crowdsaleAddress);
    }
}
